<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import Checkbox from '@/components/elements/checkbox/Checkbox';
import { $api } from '@/services';
import { useStore } from 'vuex';

const props = defineProps({
	dow: {
		type: Number,
		required: true,
	},
	menuDetail: {
		type: Object,
		required: true,
	},
});

const store = useStore();
const listDay = ref([]);
const isExist = ref(false);
const emit = defineEmits(['success']);

function dayHasMenuContent(day) {
	const week = props.menuDetail;
	if (!week?.menu_details?.length) return false;
	for (const mealGroup of week.menu_details) {
		const dayGroup = mealGroup.menu_details?.find(
			(d) => d.day_of_week === day
		);
		if (!dayGroup) continue;
		const detail = dayGroup.menu_details?.[0];
		const dishes = detail?.menu_item_dishes;
		if (Array.isArray(dishes) && dishes.length > 0) return true;
	}
	return false;
}

function checkDay(day) {
	isExist.value = false;
	if (listDay.value.includes(day)) {
		listDay.value = listDay.value.filter((d) => d !== day);
	} else {
		listDay.value.push(day);
	}
}

function selectedDaysHaveExistingMenu() {
	return listDay.value.some((day) => dayHasMenuContent(day));
}

async function submitDuplicate() {
	if (!listDay.value.length) {
		await store.dispatch('setAlertMessage', {
			message: 'Vui lòng chọn ít nhất một ngày',
			type: 'danger',
		});
		return;
	}
	if (selectedDaysHaveExistingMenu()) {
		isExist.value = true;
		return;
	}
	await doDuplicate();
}

async function doDuplicate() {
	try {
		await $api.menu.duplicateMenuByDay(props.menuDetail.id, {
			day_of_week: props.dow,
			for_day_of_weeks: listDay.value,
			menu_id: props.menuDetail.id,
		});
		emit('success');
	} catch (error) {
		console.log(error);
	}
}
</script>
<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					v-if="isExist"
					src="@/assets/images/illustrations/warning.png"
					alt="warning"
					width="60"
					height="60"
				/>
				<img
					v-else
					alt="Luca Education"
					src="@/assets/images/illustrations/duplicate.png"
					title="Luca Education"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				{{
					isExist
						? 'Ngày bạn chọn đã có thực đơn'
						: 'Sao chép nội dung thực đơn'
				}}
			</div>
			<div
				v-if="isExist"
				class="text-center text-neutral-500 mt-2 max-w-md"
			>
				Nếu tiếp tục, nội dung hiện tại của các ngày được chọn sẽ bị ghi đè
				và không thể khôi phục
			</div>
			<div class="flex items-center gap-5 mt-4" v-if="!isExist">
				<div class="text-neutral-400 font-semibold text-xs whitespace-nowrap">
					SAO CHÉP VÀO
				</div>
				<div
					v-for="i in 7"
					:key="i"
					class="flex items-center gap-1 cursor-pointer"
					@click="checkDay(i)"
				>
					<Checkbox :value="listDay.includes(i)" />
					<div
						class="uppercase text-xs text-neutral-600 whitespace-nowrap"
					>
						{{ i !== 7 ? `T${i + 1}` : 'CN' }}
					</div>
				</div>
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				Huỷ
			</button>
			<button
				v-if="isExist"
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="doDuplicate"
			>
				Ghi đè thực đơn
			</button>
			<button
				v-else
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="submitDuplicate"
				:disabled="!listDay.length"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
